/* eslint-disable react/prop-types */
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Space,
  Table,
  Tooltip,
  Select,
  notification,
  Tag,
  Row,
  Col,
  Upload,
} from 'antd';
import { get, set } from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button as CrceButton } from '@crc-evans/ui-components';
import ExcelJS from 'exceljs';
import moment from 'moment';
import history from '../../services/history';
import ChatWindow from './ChatWindow';
import {
  CloudUploadOutlined,
} from '@ant-design/icons';

import { authenticateCurrentUser } from '../../services/auth';
import { getAccess } from '../../services/teamMembers';
import { X } from 'lucide-react';
import '../DSR/DownTimeModal.css';
import '../../pages/dashboard/DashboardPage.css';
import './AssistancePage.css';

const { Option } = Select;

const AssistancePage = (props) => {
  const {} = props;
  const [fileList, setFileList] = useState([]);
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clearChat, setClearChat] = useState(false);
  const [userName, setUserName] = useState('');
  const [userGroup, setUserGroup] = useState([]);
  const llm_url = process.env.REACT_APP_LMM_ASSISTANCE;

  /** get user Access */
  useEffect(() => {
    const UserGroup = localStorage.getItem('UserGroup');
    if (!UserGroup || UserGroup === '[]') {
      authenticateCurrentUser()
        .then(async (data) => {
          let response = await getAccess(data.username);
          const userAccess = response.map((item) => item?.GroupName);
          setUserName(data.username);
          setUserGroup(userAccess);
          localStorage.setItem('UserGroup', JSON.stringify(userAccess));
        })
        .catch((error) => {
          console.log('error', error);
        });
    } else {
      try {
        const parsedUserGroup = JSON.parse(UserGroup);
        setUserGroup(parsedUserGroup);
      } catch (error) {
        console.log('Error parsing UserGroup from localStorage:', error);
        setUserGroup([]);
      }
    }
  }, [history]);

  const handleFileUpload = async (file) => {
    setLoading(true);
    const fileUrl = URL.createObjectURL(file);
    setMessages((prev) => [...prev, { text: file.name, fileUrl, sender: 'user' }]);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await fetch(`${llm_url}/upload`, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer test-token',
          // Note: Do NOT set 'Content-Type' header here
        },
        body: formData,
      });

      const data = await res.json();
      console.log(data);
      const botMsg = { text: data.status || 'No response', sender: 'bot' };
      setMessages((prev) => [...prev, botMsg]);
    } catch (error) {
      console.error('Upload failed:', error);
      const botMsg = { text: 'Upload failed. Please try again.', sender: 'bot' };
      setMessages((prev) => [...prev, botMsg]);
    } finally {
      setLoading(false);
    }

    return false; // prevent auto-upload
  };

  // Upload props
  const fileProps = {
    multiple: true, // Allow multiple files
    fileList,
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf';
      if (!isPdf) {
        notification.warning({
          message: `Please select pdf file to upload..`,
          duration: 3,
        });
        return Upload.LIST_IGNORE; // Prevent non-PDF files from being added
      }
      setFileList((prev) => [...prev, file]);
      return false; // Prevent automatic upload
    },
    onRemove: (file) => {
      setFileList((prev) => prev.filter((item) => item.uid !== file.uid));
    },
    // accept: ".xlsx,.xls,.pdf", // Allow Excel & PDF files
    accept: '.pdf',
    maxCount: 100, // Allow up to 100 files
  };
  const handleUploadFile = async () => {
    if (fileList.length === 0) {
      notification.warning({
        message: `Please select at least one file to upload.`,
        duration: 3,
      });
      return;
    }

    setUploadLoading(true);
    setDisableFileUpload(false);
    setBulkUploadModal(false);

    const formData = new FormData();

    // Append each file to the FormData
    fileList.forEach((file) => {
      formData.append('files', file); // 'files' is the key expected by the backend
    });

    // const formData = new FormData();
    // formData.append('file', fileList[0]);

    try {
      const res = await fetch(`${llm_url}/upload`, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer test-token',
          // Note: Do not set 'Content-Type' header; the browser will set it automatically
        },
        body: formData,
      });
      console.log(res);
      const data = await res.json();
      console.log(data);
      if (res.status == 200) {
        notification.success({
          message: 'Uploaded Successfully!.',
          duration: 3,
        });
      } else {
        notification.error({
          message: 'Failed to upload files.',
          duration: 3,
        });
      }

      // Reset the file list and related states
      setFileList([]);
    } catch (error) {
      console.error('Upload failed:', error);
      notification.error({
        message: 'Failed to upload files.',
        duration: 3,
      });
    } finally {
      setUploadLoading(false);
    }
  };

  console.log(userGroup, 'userGroup');
  return (
    <div className="ask-evans-page">
      <div className="ask-evans-page__header">
        <h1 className="ask-evans-page__title">Ask Evans</h1>
        <div className="ask-evans-page__actions">
          {userGroup &&
            (userGroup.includes('askevans-training-data') ||
              userGroup.includes('super-admin') ||
              userGroup.includes('admin')) && (
              <CrceButton
                label={uploadLoading ? 'Train new data....' : 'Train new data'}
                variant="tertiary"
                size="small"
                onClick={() => setBulkUploadModal(true)}
                disabled={uploadLoading}
              />
            )}
          <CrceButton
            label="Clear Chat"
            variant="tertiary"
            size="small"
            onClick={() => setClearChat(true)}
          />
        </div>
      </div>
      <hr className="ask-evans-page__rule" />
      <ChatWindow clearChat={clearChat} />

      <Modal
        width="min(92vw, 520px)"
        className="modern-create-project-modal modern-dsr-dt-add-modal ask-evans-upload-modal"
        wrapClassName="modern-dsr-dt-add-modal__wrap"
        title={(
          <h3 className="modern-dsr-dt-add-modal__h-title">Upload Files</h3>
        )}
        closeIcon={(
          <span className="modern-dsr-dt-add-modal__close-icon" aria-hidden>
            <X size={20} strokeWidth={2} />
          </span>
        )}
        centered
        visible={bulkUploadModal}
        maskStyle={{ background: 'rgba(0, 0, 0, 0.5)' }}
        onCancel={() => setBulkUploadModal(false)}
        footer={(
          <div
            className="modern-dsr-dt-add-modal__foot"
            role="group"
            aria-label="Upload file actions"
          >
            <Button
              onClick={() => {
                setBulkUploadModal(false);
                setFileList([]);
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleUploadFile}
              loading={uploadLoading}
            >
              Upload
            </Button>
          </div>
        )}
      >
        <div className="uploadFile_admin">
          <Upload
            {...fileProps}
            accept=".pdf"
            multiple
            maxCount={10}
          >
            <Button
              disabled={disableFileUpload}
              icon={<CloudUploadOutlined />}
            >
              Select Files
            </Button>
          </Upload>
        </div>
      </Modal>
    </div>
  );
};

export default connect(null, null)(AssistancePage);
